import React from 'react'
import PropTypes from 'prop-types'
import st from './VariantDel.module.scss'
import { ReactComponent as Close } from 'components/UI/icons/close-line.svg'

const VariantDel = ({ onClick, isDisabled }) => {
  return (
    <div className={st.del} onClick={onClick} disabled={isDisabled}>
      <Close />
    </div>
  )
}

VariantDel.propTypes = {
  onClick: PropTypes.func.isRequired,
}

VariantDel.defaultProps = {
  onClick: () => {},
}

export default VariantDel
